import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4" }
const _hoisted_2 = { class: "text-sm text-custom-black-350 font-medium mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")!
  const _component_BalCard = _resolveComponent("BalCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading || _ctx.stats.length === 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
            return _createVNode(_component_BalLoadingBlock, {
              key: n,
              class: "h-24"
            })
          }), 64)),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
            return _createVNode(_component_BalLoadingBlock, {
              key: n,
              class: "h-24"
            })
          }), 64))
        ], 64))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.stats, (stat, i) => {
          return (_openBlock(), _createBlock(_component_BalCard, { key: i }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, _toDisplayString(stat.label), 1),
              _createElementVNode("div", {
                class: _normalizeClass(["text-xl font-medium truncate flex items-center", { 'text-custom-blue-50': _ctx.personal }])
              }, _toDisplayString(stat.value), 3)
            ]),
            _: 2
          }, 1024))
        }), 128))
  ]))
}